import React from 'react'
import emailForgotPassword  from '../../../icons/lottieAnimations/emailForgotPassword.json';
import Lottie from "lottie-react";
import colors from '../../colors';
import { Button, Grid, Typography } from '@mui/material';
import { ReactComponent as IconClose } from '../../../icons/closeButton.svg';
import { useNavigate } from 'react-router-dom';
import {texts} from '../../general/texts'

export const RequestSent = () => {

  const navigate = useNavigate()
  return (
    <Grid container >
      <Grid container item md={10} xs={10} justifyContent={'right'} pt={10} >
        <Button sx={{fontSize:'1.8rem', color:colors.orange, borderRadius:'20px', ':hover': {background:colors.white}}} onClick={() => {navigate('/login')}} ><IconClose /></Button>
      </Grid>
      <Grid container item md={12} xs={12} justifyContent={'center'} pt={'10%'} >
          <Grid container item md={2} xs={5} >
              <Lottie animationData={emailForgotPassword} loop={false} autoplay={true} width="300" height='300' />
          </Grid>
      </Grid>
      <Grid container item md={12} xs={12} justifyContent={'center'} pt={'1%'} >
          <Typography sx={{color:colors.darkBlue, fontWeight:'bold', fontSize:'1.8rem'}} >{texts["message-request-sent"]}</Typography>
      </Grid>
      <Grid container item md={12} xs={12} justifyContent={'center'} pt={'1%'} >
          <Typography sx={{color:colors.gray, fontSize:'1.4rem'}} >{texts["message-request-pending"]}</Typography>
      </Grid>
    </Grid>
  )
}

export default RequestSent